import { Wording } from '@/types';

export const COOKING_WORDING_HR: Wording = {
  components_header_media_content: 'Videozapisi o kuhanju',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Recepti',
  components_header_text2: 'Blog',
  components_header_members: 'Članovi',
  hero_text: 'Kuhajte sa strašću, jedite s radošću',
  hero_button_text: 'Počnite kuhati već danas',
  components_ressources_section_title: 'RESURSI',
  components_ressources_subheader_text: 'Svi resursi koji su vam potrebni za učenje, kuhanje i stvaranje bolje hrane',
  components_ressources_span_text: 'Otkrijte bogatu kolekciju video recepata, detaljnih vodiča za kuhanje i stručnih uvida o sparivanju okusa, prezentaciji hrane i kulinarskoj kreativnosti.',
  components_ressources_card_1_title: 'Inspiracija za kuhanje',
  components_ressources_card_1_text: 'Inspirirajte se kreativnim receptima i videozapisima kuhanja.',
  components_ressources_card_2_title: 'Znanje kuhanja',
  components_ressources_card_2_text: 'Naučite bitne tehnike kuhanja, kombinacije okusa i osnove sparivanja hrane kroz jasne i praktične vodiče.',
  components_ressources_link: 'Pogledajte videozapise',
  components_notes_and_google_title_1: 'Kulinarsko obrazovanje',
  components_notes_and_google_title_2: 'Svakodnevno kuhanje',
  components_notes_and_google_title_3: 'Dosljedne kulinarske vještine',
  components_review_google_text: 'Recenzije na Googleu',
  media_content_section_title: 'Videozapisi o kuhanju',
  media_content_section_subheader_text: 'Istražite recepte i videozapise kuhanja korak po korak.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Više videozapisa',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Vodiči i članci',
  text2_section_button_more: 'Više članaka',
  components_text1_section_title: 'RECEPTI',
  components_text1_subheader_text: 'Ukusni recepti za svakodnevno kuhanje',
  components_text1_span_text: 'Otkrijte jednostavne recepte osmišljene za svakodnevne obroke, jasne korake i izvrsne rezultate.',
  components_text1_card_1_title: 'Započnite svoj dan kako treba',
  components_text1_card_1_text: 'Jednostavni i ukusni recepti za lagan i aromatičan početak dana.',
  components_text1_card_3_title: 'Ideje za ukusan ručak',
  components_text1_card_3_text: 'Ukusni recepti za ručak koji se lako pripremaju i puni su okusa.',
  components_text1_card_2_title: 'Utješni recepti za večeru',
  components_text1_card_2_text: 'Topli, zadovoljavajući recepti za večeru savršeni za opuštene večeri kod kuće.',
  components_text1_link: 'Pogledajte sve recepte',
  components_footer_text: 'Naučite bolje kuhati, stvorite bolju hranu: Vaša kuhinja, vaše putovanje.',
  components_footer_info: 'Informacije',
  components_footer_registration_number: 'Registarski broj',
  components_footer_legal: 'Pravno',
  components_footer_terms: 'Uvjeti i odredbe',
  components_footer_privacy: 'Pravila o privatnosti',
  button_load_more: 'Učitaj više',
  page_media_1_content_hero_text: 'Otkrijte jednostavne videozapise kuhanja za svačiji ukus',
  page_text1_hero_text: 'Recepti',
  page_text1_section_title: 'Savjeti za kuhanje',
  page_text1_subheader_text: 'Recepti',
  page_text2_hero_text: 'Naš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Vodiči i članci',
  enter_email_title: 'Molimo unesite svoju e-poštu za nastavak',
  enter_email_placeholder_email: 'E-pošta',
  enter_email_button_enter: 'Unesi',
  components_login_success_text: 'Prijava uspješna!',
  components_card_link_media_content: 'Gledajte sada',
  components_card_link_text1_content: 'Pogledajte recept',
  components_card_link_text2_content: 'Pogledajte članak',
};